"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const KeyValueItem = _ref => {
  let {
    term,
    termIcon,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("dt", null, termIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "term-icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: termIcon,
    size: "24"
  })), term), /*#__PURE__*/_react.default.createElement("dd", null, children));
};

KeyValueItem.propTypes = {
  term: _propTypes.default.string.isRequired,
  termIcon: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
KeyValueItem.defaultProps = {
  termIcon: undefined
};
var _default = KeyValueItem;
exports.default = _default;